'use strict';

// Lock controls are server-rendered HTMX forms.
window.dndNextLevel = window.dndNextLevel || {};
